var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4999_10973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 14,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55556 5.06239C3.32544 5.06239 3.13889 5.23961 3.13889 5.45822V12.8471C3.13889 13.0657 3.32544 13.2429 3.55556 13.2429H11.3333C11.5635 13.2429 11.75 13.0657 11.75 12.8471V9.15267C11.75 8.78831 12.0609 8.49295 12.4444 8.49295C12.828 8.49295 13.1389 8.78831 13.1389 9.15267V12.8471C13.1389 13.7944 12.3305 14.5624 11.3333 14.5624H3.55556C2.55838 14.5624 1.75 13.7944 1.75 12.8471V5.45822C1.75 4.5109 2.55837 3.74295 3.55556 3.74295H7.44444C7.82798 3.74295 8.13889 4.03831 8.13889 4.40267C8.13889 4.76702 7.82798 5.06239 7.44444 5.06239H3.55556Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60816 9.8392L12.5792 6.06674L10.693 4.27489L6.722 8.04735C6.66733 8.09935 6.6285 8.16444 6.60962 8.23571L6.16949 10.3641L8.40946 9.94596C8.48467 9.9281 8.55346 9.89116 8.60816 9.8392ZM13.8611 4.8489C14.0213 4.69664 14.1113 4.49017 14.1113 4.27489C14.1113 4.0596 14.0213 3.85313 13.8611 3.70088L13.1834 3.05705C13.0231 2.90484 12.8058 2.81934 12.5792 2.81934C12.3526 2.81934 12.1352 2.90484 11.975 3.05705L11.2972 3.70088L13.1834 5.49273L13.8611 4.8489Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4999_10973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.33301,
    y: 2.2915,
    width: 13.3333,
    height: 12.6667,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.0c66d870cf9b2e6173e0990031d61485.svg";
export { ForwardRef as ReactComponent };